import "./App.scss";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { chmRoutes } from "./routing/CambioRouteObjects";
import { celinkRoutes } from "./routing/CelinkRouteObject";
import { demoRoutes } from "./routing/DemoRouteObjects";
import { fcmRoutes } from "./routing/FCMRouteObjects";
import { flexpointRoutes } from "./routing/FlexpointRouteObjects";
import { grateRoutes } from "./routing/GRateRouteObjects";
import { pmgRoutes } from "./routing/PanoramaRouteObjects";
import { prmgUATModeRoutes, prmgProdRoutes } from "./routing/PRMGRouteObjects";
import { radiusRoutes } from "./routing/RadiusRouteObjects";
import { reliantRoutes } from "./routing/ReliantRouteObject";
import { northernMortgageRoutes } from "./routing/NorthernMortgageRouteObjects";
import { mainRoutes, landingPageRoutes } from "./routing/MainRoutes";
import { RouterError } from "./components/RouterError";
import { loanStoreRoutes } from "./routing/LoanStoreRouteObjects";
import { dinerCapRoutes } from "./routing/DinerCapRouteObjects";
import { betterRoutes } from "./routing/BetterRouteObjects";
import { northPointRoutes } from "./routing/NorthPointRouteObject";

const router = createBrowserRouter([
  {
    errorElement: <RouterError />,
  },
  celinkRoutes,
  chmRoutes,
  demoRoutes,
  fcmRoutes,
  flexpointRoutes,
  grateRoutes,
  landingPageRoutes,
  mainRoutes,
  northernMortgageRoutes,
  pmgRoutes,
  prmgProdRoutes,
  prmgUATModeRoutes,
  radiusRoutes,
  reliantRoutes,
  loanStoreRoutes,
  dinerCapRoutes,
  betterRoutes,
  northPointRoutes
]);

export default function App() {
  return <RouterProvider router={router} />;
}
